import React from 'react';
import AddEditTemplateForm from 'ui-component/Template/AddEditTemplateForm';

function EditTemplate () {
  return (
    <div>
      <AddEditTemplateForm title="Edit Template" />
    </div>
  )
}

export default  EditTemplate;